import { render, staticRenderFns } from "./SpinnerComp.vue?vue&type=template&id=0d8918ac&scoped=true&"
import script from "./SpinnerComp.vue?vue&type=script&lang=js&"
export * from "./SpinnerComp.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerComp.vue?vue&type=style&index=0&id=0d8918ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8918ac",
  null
  
)

export default component.exports